// (function(){
//   if (window.__PetSoReferenceScriptLoaded) return;
//   window.__PetSoReferenceScriptLoaded = true;

//   var STORAGE_KEY = 'petso:dog-name';
//   var DEFAULT_NAME = 'Bruno';
//   var DEFAULT_ROTATING_NAMES = ['Luna','Max','Bella','Cooper','Daisy','Milo','Rosie','Finn','Nala','Charlie','Olive','Bruno'];
//   var ROTATION_INTERVAL = 2400;
//   var ROTATION_TRANSITION = 320;
//   var NAME_TEXT_PATTERN = /(Bruno’s|Bruno's|Milo’s|Milo's|Biscuit’s|Biscuit's|your dog’s|your dog's|your pet’s|your pet's|Bruno|Milo|Biscuit|your dog|your pet)/gi;
//   var autoPromptScheduled = false;

//   function cleanName(value){
//     value = (value || '').toString().trim();
//     return value ? value.slice(0, 32) : DEFAULT_NAME;
//   }

//   function getStoredPetName(){
//     try { return localStorage.getItem(STORAGE_KEY); }
//     catch(e){ return null; }
//   }

//   function getPetName(){
//     return cleanName(getStoredPetName());
//   }

//   function setPetName(value){
//     var name = cleanName(value);
//     try { localStorage.setItem(STORAGE_KEY, name); } catch(e){}
//     try { sessionStorage.removeItem(STORAGE_KEY + ':dismissed'); } catch(e){}
//     document.documentElement.style.setProperty('--petso-current-name-length', String(name.length));
//     window.PetSoPetName = name;
//     applyPetName(name);
//     initRotatingNames();
//     return name;
//   }

//   function possessive(name){
//     return /s$/i.test(name) ? name + '’' : name + '’s';
//   }

//   function isPossessiveToken(token){
//     return /(?:’s|'s)$/i.test(token || '');
//   }

//   function tokenMode(token){
//     return isPossessiveToken(token) ? 'possessive' : 'name';
//   }

//   function replacementForToken(token, name){
//     return tokenMode(token) === 'possessive' ? possessive(name) : name;
//   }

//   function preparePetNameTrigger(el){
//     if(!el) return;
//     el.classList.add('petso-name-trigger');
//     if(!el.hasAttribute('data-petso-name-trigger')) el.setAttribute('data-petso-name-trigger', '');
//     if(!el.hasAttribute('role')) el.setAttribute('role', 'button');
//     if(!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
//     el.setAttribute('aria-label', "Change your dog's name");
//     el.setAttribute('title', "Change your dog's name");
//   }

//   function preparePetNameTriggers(root){
//     (root || document).querySelectorAll('[data-petso-name-trigger], [data-petso-pet-name], [data-petso-pet-possessive]').forEach(preparePetNameTrigger);
//   }

//   function createNameTrigger(text, mode){
//     var span = document.createElement('span');
//     span.className = 'petso-name-trigger petso-inline-name';
//     span.setAttribute('data-petso-name-trigger', '');
//     span.setAttribute('data-petso-generated-name', '');
//     span.setAttribute('data-petso-name-mode', mode || 'name');
//     span.setAttribute(mode === 'possessive' ? 'data-petso-pet-possessive' : 'data-petso-pet-name', '');
//     span.textContent = text;
//     preparePetNameTrigger(span);
//     return span;
//   }

//   function updateGeneratedNameTriggers(root, name){
//     (root || document).querySelectorAll('[data-petso-generated-name]').forEach(function(el){
//       var mode = el.getAttribute('data-petso-name-mode') || 'name';
//       el.textContent = mode === 'possessive' ? possessive(name) : name;
//       preparePetNameTrigger(el);
//     });
//   }

//   function replaceTextNodeWithNameTriggers(node, name){
//     var original = node.nodeValue || '';
//     NAME_TEXT_PATTERN.lastIndex = 0;
//     if(!NAME_TEXT_PATTERN.test(original)) return;

//     NAME_TEXT_PATTERN.lastIndex = 0;
//     var fragment = document.createDocumentFragment();
//     var cursor = 0;
//     var match;

//     while((match = NAME_TEXT_PATTERN.exec(original)) !== null){
//       if(match.index > cursor){
//         fragment.appendChild(document.createTextNode(original.slice(cursor, match.index)));
//       }
//       fragment.appendChild(createNameTrigger(replacementForToken(match[0], name), tokenMode(match[0])));
//       cursor = match.index + match[0].length;
//     }

//     if(cursor < original.length){
//       fragment.appendChild(document.createTextNode(original.slice(cursor)));
//     }

//     if(node.parentNode) node.parentNode.replaceChild(fragment, node);
//   }

//   function applyTextReplacement(root, name){
//     if(!root) return;
//     updateGeneratedNameTriggers(root, name);

//     var skip = { SCRIPT:1, STYLE:1, NOSCRIPT:1, TEMPLATE:1, INPUT:1, TEXTAREA:1, SELECT:1, OPTION:1 };
//     var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
//       acceptNode: function(node){
//         var p = node.parentElement;
//         if(!p || skip[p.tagName] || p.closest('[data-petso-no-name-replace], [data-petso-name-trigger]')) return NodeFilter.FILTER_REJECT;
//         var text = node.nodeValue || '';
//         NAME_TEXT_PATTERN.lastIndex = 0;
//         return NAME_TEXT_PATTERN.test(text) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
//       }
//     });
//     var nodes = [];
//     while(walker.nextNode()) nodes.push(walker.currentNode);
//     nodes.forEach(function(node){ replaceTextNodeWithNameTriggers(node, name); });
//   }

//   function applyPetName(name){
//     document.querySelectorAll('[data-petso-pet-name]').forEach(function(el){ el.textContent = name; });
//     document.querySelectorAll('[data-petso-pet-possessive]').forEach(function(el){ el.textContent = possessive(name); });
//     document.querySelectorAll('[data-petso-pet-placeholder]').forEach(function(el){ el.setAttribute('placeholder', 'e.g. ' + name); });
//     document.querySelectorAll('.petso-page, .petso-page-fragment, .petso-site-header, .petso-site-footer').forEach(function(el){ applyTextReplacement(el, name); });
//     preparePetNameTriggers(document);
//   }

//   function reveal(){
//     var els=document.querySelectorAll('.petso-reveal');
//     if(!('IntersectionObserver' in window)){
//       els.forEach(function(e){e.classList.add('is-visible')});
//       return;
//     }
//     var io=new IntersectionObserver(function(entries){
//       entries.forEach(function(entry){
//         if(entry.isIntersecting){
//           entry.target.classList.add('is-visible');
//           io.unobserve(entry.target);
//         }
//       });
//     },{threshold:.12,rootMargin:'0px 0px -60px 0px'});
//     els.forEach(function(e){
//       if(e.__petsoRevealReady || e.classList.contains('is-visible')) return;
//       e.__petsoRevealReady = true;
//       io.observe(e);
//     });
//   }

//   function stopNameRotation(el){
//     if(el.__petsoRotationTimer){
//       window.clearInterval(el.__petsoRotationTimer);
//       el.__petsoRotationTimer = null;
//     }
//     if(el.__petsoRotationSwapTimer){
//       window.clearTimeout(el.__petsoRotationSwapTimer);
//       el.__petsoRotationSwapTimer = null;
//     }
//   }

//   function initRotatingNames(){
//     var storedName = getStoredPetName();
//     document.querySelectorAll('[data-petso-rotating-name]').forEach(function(el){
//       stopNameRotation(el);
//       preparePetNameTrigger(el);

//       if(storedName){
//         el.classList.remove('is-changing');
//         el.textContent = cleanName(storedName);
//         el.setAttribute('data-petso-pet-name','');
//         return;
//       }

//       el.removeAttribute('data-petso-pet-name');
//       var index = Number(el.getAttribute('data-petso-name-index') || 0) % DEFAULT_ROTATING_NAMES.length;
//       el.textContent = DEFAULT_ROTATING_NAMES[index];

//       el.__petsoRotationTimer = window.setInterval(function(){
//         el.classList.add('is-changing');
//         el.__petsoRotationSwapTimer = window.setTimeout(function(){
//           index = (index + 1) % DEFAULT_ROTATING_NAMES.length;
//           el.setAttribute('data-petso-name-index', String(index));
//           el.textContent = DEFAULT_ROTATING_NAMES[index];
//           el.classList.remove('is-changing');
//         }, ROTATION_TRANSITION);
//       }, ROTATION_INTERVAL);
//     });
//   }

//   function getNameModals(){
//     return Array.prototype.slice.call(document.querySelectorAll('[data-petso-name-modal]'));
//   }

//   function getPrimaryNameModal(){
//     var modals = getNameModals();
//     if(!modals.length) return null;
//     var pageModal = modals.filter(function(modal){ return !!modal.closest('#MainContent'); })[0];
//     return pageModal || modals[0];
//   }

//   function closeNameModal(modal){
//     if(!modal) return;
//     modal.classList.remove('is-open');
//     modal.setAttribute('aria-hidden','true');
//     modal.removeAttribute('data-petso-manual-open');
//     document.documentElement.classList.remove('petso-modal-open');
//   }

//   function updateNameSubmitState(modal){
//     if(!modal) return;
//     var input = modal.querySelector('[data-petso-name-input]');
//     var start = modal.querySelector('[data-petso-name-submit]');
//     if(start) start.disabled = !(input && input.value.trim());
//   }

//   function saveNameFromModal(modal){
//     var input = modal && modal.querySelector('[data-petso-name-input]');
//     if(!input || !input.value.trim()){
//       updateNameSubmitState(modal);
//       return;
//     }
//     setPetName(input.value);
//     closeNameModal(modal);
//   }

//   function dismissNameModal(modal){
//     try { sessionStorage.setItem(STORAGE_KEY + ':dismissed', '1'); } catch(e){}
//     closeNameModal(modal);
//   }

//   function setupNameModal(modal){
//     if(!modal || modal.__petsoModalReady) return;
//     modal.__petsoModalReady = true;

//     var input = modal.querySelector('[data-petso-name-input]');
//     var start = modal.querySelector('[data-petso-name-submit]');
//     var skip = modal.querySelector('[data-petso-name-skip]');

//     if(start) start.addEventListener('click', function(){ saveNameFromModal(modal); });
//     if(skip) skip.addEventListener('click', function(){ dismissNameModal(modal); });
//     modal.addEventListener('click', function(event){ if(event.target === modal) dismissNameModal(modal); });

//     if(input){
//       input.addEventListener('keydown', function(e){
//         if(e.key === 'Enter'){
//           e.preventDefault();
//           saveNameFromModal(modal);
//         }
//       });
//       input.addEventListener('input', function(){ updateNameSubmitState(modal); });
//     }

//     updateNameSubmitState(modal);
//   }

//   function openPetNameModal(prefillCurrentName){
//     var modal = getPrimaryNameModal();
//     if(!modal) return;
//     setupNameModal(modal);

//     var input = modal.querySelector('[data-petso-name-input]');
//     if(input){
//       input.value = prefillCurrentName && getStoredPetName() ? cleanName(getStoredPetName()) : '';
//       updateNameSubmitState(modal);
//     }

//     modal.setAttribute('data-petso-manual-open', prefillCurrentName ? 'true' : 'false');
//     modal.classList.add('is-open');
//     modal.setAttribute('aria-hidden','false');
//     document.documentElement.classList.add('petso-modal-open');
//     window.setTimeout(function(){ if(input) input.focus(); }, 160);
//   }

//   function petNameModal(){
//     var modals = getNameModals();
//     if(!modals.length) return;
//     modals.forEach(setupNameModal);

//     window.PetSoOpenNameModal = function(){ openPetNameModal(true); };

//     var hasName = !!getStoredPetName();
//     var dismissed = false;
//     try { dismissed = sessionStorage.getItem(STORAGE_KEY + ':dismissed') === '1'; } catch(e){}

//     if(!hasName && !dismissed && !autoPromptScheduled){
//       autoPromptScheduled = true;
//       window.setTimeout(function(){
//         if(!getStoredPetName()) openPetNameModal(false);
//       }, 1400);
//     }
//   }

//   function setupPetNameTriggerEvents(){
//     if(window.__PetSoNameTriggerEventsReady) return;
//     window.__PetSoNameTriggerEventsReady = true;

//     document.addEventListener('click', function(event){
//       var trigger = event.target && event.target.closest && event.target.closest('[data-petso-name-trigger]');
//       if(!trigger || trigger.closest('[data-petso-name-modal]')) return;
//       event.preventDefault();
//       event.stopPropagation();
//       openPetNameModal(true);
//     });

//     document.addEventListener('keydown', function(event){
//       var trigger = event.target && event.target.closest && event.target.closest('[data-petso-name-trigger]');
//       if(!trigger || trigger.closest('[data-petso-name-modal]')) return;
//       if(event.key !== 'Enter' && event.key !== ' ') return;
//       event.preventDefault();
//       openPetNameModal(true);
//     });
//   }

//   function normalizeCategory(value){
//     return (value || '')
//       .toString()
//       .replace(/&amp;/g, '&')
//       .replace(/\u00a0/g, ' ')
//       .replace(/\s+/g, ' ')
//       .trim()
//       .toLowerCase();
//   }

//   function hubFilters(){
//     document.querySelectorAll('[data-petso-hub]').forEach(function(wrap){
//       if(wrap.__petsoHubFiltersReady) return;
//       wrap.__petsoHubFiltersReady = true;

//       var buttons = Array.prototype.slice.call(wrap.querySelectorAll('[data-petso-category-filter]'));
//       var cards = Array.prototype.slice.call(wrap.querySelectorAll('[data-petso-article-category]'));
//       var feature = wrap.querySelector('[data-petso-feature-category]');
//       var empty = wrap.querySelector('[data-petso-filter-empty]');

//       function itemMatches(item, selected){
//         if(selected === 'all') return true;
//         var raw = item.getAttribute('data-petso-article-category') || item.getAttribute('data-petso-feature-category') || '';
//         return normalizeCategory(raw) === selected;
//       }

//       function applyFilter(selectedRaw){
//         var selected = normalizeCategory(selectedRaw || 'all');
//         var visibleCount = 0;

//         buttons.forEach(function(button){
//           var active = normalizeCategory(button.getAttribute('data-petso-category-filter')) === selected;
//           button.classList.toggle('is-active', active);
//           button.setAttribute('aria-pressed', active ? 'true' : 'false');
//         });

//         if(feature){
//           var showFeature = itemMatches(feature, selected);
//           feature.hidden = !showFeature;
//           feature.style.setProperty('display', showFeature ? '' : 'none', 'important');
//         }

//         cards.forEach(function(card){
//           var show = itemMatches(card, selected);
//           card.hidden = !show;
//           card.style.setProperty('display', show ? '' : 'none', 'important');
//           if(show){
//             visibleCount += 1;
//             card.classList.add('is-visible');
//           }
//         });

//         if(empty){
//           empty.hidden = visibleCount > 0;
//           empty.style.setProperty('display', visibleCount > 0 ? 'none' : 'block', 'important');
//         }
//       }

//       buttons.forEach(function(btn){
//         btn.addEventListener('click', function(event){
//           event.preventDefault();
//           applyFilter(btn.getAttribute('data-petso-category-filter') || 'all');
//         });
//       });

//       var activeButton = wrap.querySelector('[data-petso-category-filter].is-active') || buttons[0];
//       if(activeButton) applyFilter(activeButton.getAttribute('data-petso-category-filter') || 'all');
//     });
//   }


//   function waitlistSubmission(){
//     document.querySelectorAll('[data-petso-waitlist-card]').forEach(function(card){
//       if(card.__petsoWaitlistReady) return;
//       card.__petsoWaitlistReady = true;
//       var form = card.querySelector('form');
//       if(!form) return;
//       form.addEventListener('submit', function(){
//         card.classList.add('is-submitted');
//       });
//     });
//   }

//   function bootPetSoPersonalization(){
//     reveal();
//     initRotatingNames();
//     applyPetName(getPetName());
//     setupPetNameTriggerEvents();
//     petNameModal();
//     hubFilters();
//     waitlistSubmission();
//   }

//   document.addEventListener('DOMContentLoaded', bootPetSoPersonalization);
//   document.addEventListener('shopify:section:load', bootPetSoPersonalization);
// })();
// (function(){
//   if (window.__PetSoPdpScriptLoaded) return;
//   window.__PetSoPdpScriptLoaded = true;

//   var CURRENCY_DECIMALS = {
//     BIF: 0, CLP: 0, DJF: 0, GNF: 0, ISK: 0, JPY: 0, KMF: 0, KRW: 0, PYG: 0, RWF: 0, UGX: 0, VND: 0, VUV: 0, XAF: 0, XOF: 0, XPF: 0,
//     BHD: 3, IQD: 3, JOD: 3, KWD: 3, LYD: 3, OMR: 3, TND: 3
//   };

//   function moneyPrecision(currency){
//     currency = String(currency || '').toUpperCase();
//     return Object.prototype.hasOwnProperty.call(CURRENCY_DECIMALS, currency) ? CURRENCY_DECIMALS[currency] : 2;
//   }

//   function formatCents(cents, thousands, decimal, precision, divisor){
//     var n = (Number(cents || 0) / divisor).toFixed(precision);
//     var parts = n.split('.');
//     parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
//     return precision > 0 ? parts[0] + decimal + (parts[1] || '').padEnd(precision, '0') : parts[0];
//   }

//   function shopifyMoney(cents, format, currency){
//     var precision = moneyPrecision(currency);
//     var divisor = Math.pow(10, precision);
//     return String(format || '').replace(/{{\s*(\w+)\s*}}/g, function(_, token){
//       var thousands = ',';
//       var decimal = '.';
//       var displayPrecision = precision;
//       if (token === 'currency') return currency || '';
//       if (token === 'amount_no_decimals') displayPrecision = 0;
//       if (token === 'amount_with_comma_separator') { thousands = '.'; decimal = ','; }
//       if (token === 'amount_no_decimals_with_comma_separator') { thousands = '.'; decimal = ','; displayPrecision = 0; }
//       if (token === 'amount_no_decimals_with_space_separator') { thousands = ' '; displayPrecision = 0; }
//       if (token === 'amount_with_space_separator') { thousands = ' '; decimal = ','; }
//       if (token === 'amount_with_period_and_space_separator') { thousands = ' '; decimal = '.'; }
//       if (token === 'amount_with_apostrophe_separator') { thousands = "'"; decimal = '.'; }
//       return formatCents(cents, thousands, decimal, displayPrecision, divisor);
//     });
//   }

//   function money(cents, root){
//     cents = Number(cents || 0);
//     var currency = 'USD';
//     var format = '';
//     try {
//       currency = (root && root.getAttribute('data-petso-currency')) || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || currency;
//       format = (root && root.getAttribute('data-petso-money-format')) || '';
//     } catch(e) {}
//     if (format && /{{\s*\w+\s*}}/.test(format)) {
//       return shopifyMoney(cents, format, currency);
//     }
//     try {
//       return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(cents / Math.pow(10, moneyPrecision(currency)));
//     } catch(e) {
//       return (cents / 100).toFixed(2);
//     }
//   }

//   function intValue(input){
//     var n = parseInt(input && input.value, 10);
//     if (!Number.isFinite(n) || n < 1) n = 1;
//     return n;
//   }

//   function uniqueSectionIds(){
//     var ids = [];
//     document.querySelectorAll('cart-items-component[data-section-id]').forEach(function(el){
//       var id = el.getAttribute('data-section-id');
//       if (id && ids.indexOf(id) === -1) ids.push(id);
//     });
//     return ids;
//   }

//   function route(path){
//     var root = '/';
//     try { root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; } catch(e) {}
//     return root.replace(/\/$/, '') + path;
//   }

//   function safeCartCount(cart){
//     var count = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
//     count = Number(count || 0);
//     return Number.isFinite(count) && count > 0 ? count : 0;
//   }

//   function updateCartBubbleMarkup(cart){
//     var count = safeCartCount(cart);

//     document.querySelectorAll('cart-icon.header-actions__cart-icon, .header-actions__cart-icon').forEach(function(icon){
//       icon.classList.toggle('header-actions__cart-icon--has-cart', count > 0);
//     });

//     document.querySelectorAll('.cart-bubble').forEach(function(bubble){
//       bubble.classList.toggle('visually-hidden', count <= 0);
//       bubble.setAttribute('aria-hidden', count > 0 ? 'false' : 'true');

//       var countNode = bubble.querySelector('[ref="cartBubbleCount"], .cart-bubble__text-count');
//       if (countNode) {
//         countNode.textContent = count > 99 ? '' : String(count);
//         countNode.classList.toggle('hidden', count <= 0);
//       }
//     });

//     try {
//       sessionStorage.setItem('cart-count', JSON.stringify({ value: String(count), timestamp: Date.now() }));
//     } catch(e) {}
//   }

//   function announceCartUpdate(cart){
//     var count = safeCartCount(cart);
//     document.querySelectorAll('[data-testid="cart-count-live-region"], [data-petso-live-region]').forEach(function(region){
//       region.textContent = count > 0 ? ('Cart updated. ' + count + ' item' + (count === 1 ? '' : 's') + ' in cart.') : 'Cart is empty.';
//     });
//   }

//   function parseProduct(root){
//     var script = root.querySelector('[data-petso-product-json]');
//     if (!script) return null;
//     try { return JSON.parse(script.textContent || '{}'); }
//     catch(e) { return null; }
//   }

//   function getSelectedOptions(root){
//     return Array.prototype.map.call(root.querySelectorAll('[data-petso-option-index]'), function(fieldset){
//       var selected = fieldset.querySelector('[data-petso-option-value].is-selected') || fieldset.querySelector('[data-petso-option-value]');
//       return selected ? selected.getAttribute('data-petso-option-value') : '';
//     });
//   }

//   function findVariant(product, selectedOptions){
//     if (!product || !Array.isArray(product.variants)) return null;
//     if (!selectedOptions.length && product.variants.length) return product.variants[0];
//     return product.variants.find(function(variant){
//       return Array.isArray(variant.options) && variant.options.every(function(option, index){
//         return String(option) === String(selectedOptions[index]);
//       });
//     }) || null;
//   }

//   function setSelectedOptionLabels(root, selectedOptions){
//     selectedOptions.forEach(function(value, index){
//       var label = root.querySelector('[data-petso-selected-option="' + index + '"]');
//       if (label) label.textContent = value;
//     });
//   }

//   function updateAvailability(root, product, selectedOptions){
//     root.querySelectorAll('[data-petso-option-index]').forEach(function(fieldset){
//       var index = Number(fieldset.getAttribute('data-petso-option-index'));
//       fieldset.querySelectorAll('[data-petso-option-value]').forEach(function(button){
//         var test = selectedOptions.slice();
//         test[index] = button.getAttribute('data-petso-option-value') || '';
//         var variant = findVariant(product, test);
//         button.classList.toggle('is-unavailable', !!variant && variant.available === false);
//       });
//     });
//   }

//   function activateMedia(root, mediaId, fallbackIndex){
//     var selector = null;
//     if (mediaId) selector = '[data-petso-media-id="' + mediaId + '"]';
//     if (!selector && fallbackIndex !== undefined && fallbackIndex !== null) selector = '[data-petso-fallback-media="' + fallbackIndex + '"]';
//     if (!selector) return;

//     var main = root.querySelector('[data-petso-main-media]' + selector);
//     var thumb = root.querySelector('[data-petso-thumb]' + selector);
//     if (!main) return;

//     root.querySelectorAll('[data-petso-main-media]').forEach(function(el){ el.classList.remove('is-active'); });
//     root.querySelectorAll('[data-petso-thumb]').forEach(function(el){ el.classList.remove('is-active'); });
//     main.classList.add('is-active');
//     if (thumb) thumb.classList.add('is-active');
//   }

//   function variantMediaId(variant){
//     if (!variant) return null;
//     if (variant.featured_media && variant.featured_media.id) return String(variant.featured_media.id);
//     if (variant.featured_image && variant.featured_image.id) return String(variant.featured_image.id);
//     return null;
//   }

//   function updatePdp(root, product){
//     var selectedOptions = getSelectedOptions(root);
//     var variant = findVariant(product, selectedOptions);
//     var qtyInput = root.querySelector('[data-petso-qty]');
//     var qty = intValue(qtyInput);
//     if (qtyInput) qtyInput.value = qty;

//     setSelectedOptionLabels(root, selectedOptions);
//     updateAvailability(root, product, selectedOptions);

//     var idInput = root.querySelector('[data-petso-variant-id]');
//     var price = root.querySelector('[data-petso-price]');
//     var compare = root.querySelector('[data-petso-compare-price]');
//     var badge = root.querySelector('[data-petso-discount-badge]');
//     var add = root.querySelector('[data-petso-add-to-cart]');
//     var defaultLabel = root.querySelector('.petso-pdp-atc__default');
//     var status = root.querySelector('[data-petso-status]');
//     var availableText = status ? (status.getAttribute('data-available-text') || 'Checkout opens at launch. Shopify-powered, secure payments.') : '';
//     var unavailableText = status ? (status.getAttribute('data-unavailable-text') || 'This variant is currently unavailable.') : '';

//     if (!variant) {
//       if (add) add.disabled = true;
//       if (defaultLabel) defaultLabel.textContent = 'Unavailable';
//       if (status) status.textContent = unavailableText;
//       return null;
//     }

//     if (idInput) idInput.value = variant.id;
//     if (price) price.textContent = money(variant.price, root);

//     if (compare) {
//       var defaultBadge = badge ? (badge.getAttribute('data-petso-badge-default') || '') : '';
//       if (variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price)) {
//         compare.textContent = money(variant.compare_at_price, root);
//         compare.classList.remove('is-hidden');
//         if (badge) {
//           var discount = Math.round((Number(variant.compare_at_price) - Number(variant.price)) * 100 / Number(variant.compare_at_price));
//           badge.textContent = defaultBadge || ('Save ' + discount + '%');
//           badge.hidden = false;
//         }
//       } else {
//         compare.textContent = '';
//         compare.classList.add('is-hidden');
//         if (badge) {
//           badge.textContent = defaultBadge;
//           badge.hidden = !defaultBadge;
//         }
//       }
//     }

//     if (defaultLabel) {
//       defaultLabel.innerHTML = (variant.available ? 'Add to cart' : 'Sold out') + ' — <span data-petso-total-price>' + money(Number(variant.price) * qty, root) + '</span>';
//     }
//     if (add) add.disabled = !variant.available;
//     if (status) {
//       status.textContent = variant.available ? availableText : unavailableText;
//     }

//     var mediaId = variantMediaId(variant);
//     if (mediaId) activateMedia(root, mediaId, null);

//     try {
//       var url = new URL(window.location.href);
//       url.searchParams.set('variant', variant.id);
//       window.history.replaceState({}, '', url.toString());
//     } catch(e) {}

//     return variant;
//   }

//   function dispatchCartUpdate(cart, addResponse, variantId){
//     var sections = addResponse && addResponse.sections ? addResponse.sections : {};
//     var itemCount = safeCartCount(cart);

//     updateCartBubbleMarkup(cart);
//     announceCartUpdate(cart);

//     document.dispatchEvent(new CustomEvent('cart:update', {
//       bubbles: true,
//       detail: {
//         resource: cart || {},
//         sourceId: 'petso-product-form',
//         data: {
//           // Keep this different from product-form-component because the value below is the full cart count.
//           source: 'petso-product-form',
//           itemCount: itemCount,
//           variantId: variantId ? String(variantId) : undefined,
//           sections: sections
//         }
//       }
//     }));
//   }

//   function openCartDrawer(){
//     var drawer = document.querySelector('cart-drawer-component');
//     var trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
//     if (!drawer) {
//       if (trigger) trigger.click();
//       return;
//     }
//     var open = function(){
//       if (typeof drawer.open === 'function') drawer.open();
//       else if (typeof drawer.showDialog === 'function') drawer.showDialog();
//       else if (trigger) trigger.click();
//     };
//     if (window.customElements && customElements.whenDefined) {
//       customElements.whenDefined('cart-drawer-component').then(function(){ window.setTimeout(open, 40); }).catch(function(){ if (trigger) trigger.click(); });
//     } else {
//       window.setTimeout(open, 40);
//     }
//   }

//   function submitAddToCart(root, product, event){
//     event.preventDefault();
//     var form = event.currentTarget;
//     var variant = updatePdp(root, product);
//     var button = root.querySelector('[data-petso-add-to-cart]');
//     var error = root.querySelector('[data-petso-form-error]');
//     var live = root.querySelector('[data-petso-live-region]');

//     if (!variant || !variant.available) return;
//     if (error) {
//       error.hidden = true;
//       error.textContent = '';
//     }
//     if (button) {
//       button.disabled = true;
//       button.classList.remove('is-added');
//       button.setAttribute('aria-busy', 'true');
//     }

//     var formData = new FormData(form);
//     formData.set('id', String(variant.id));
//     var qtyInput = root.querySelector('[data-petso-qty]');
//     formData.set('quantity', String(intValue(qtyInput)));

//     var sections = uniqueSectionIds();
//     if (sections.length) {
//       formData.set('sections', sections.join(','));
//       formData.set('sections_url', window.location.pathname);
//     }

//     fetch(route('/cart/add.js'), {
//       method: 'POST',
//       body: formData,
//       headers: { 'Accept': 'application/json' },
//       credentials: 'same-origin'
//     })
//       .then(function(response){ return response.json().then(function(json){ return { ok: response.ok, json: json }; }); })
//       .then(function(result){
//         if (!result.ok || result.json.status) {
//           var message = result.json.description || result.json.message || 'Could not add this item to cart.';
//           throw new Error(Array.isArray(message) ? message.join(', ') : message);
//         }
//         return fetch(route('/cart.js'), { credentials: 'same-origin' })
//           .then(function(response){ return response.json(); })
//           .then(function(cart){ return { cart: cart, addResponse: result.json }; });
//       })
//       .then(function(result){
//         dispatchCartUpdate(result.cart, result.addResponse, variant.id);
//         window.setTimeout(openCartDrawer, 90);
//         if (button) {
//           button.classList.add('is-added');
//           window.setTimeout(function(){ button.classList.remove('is-added'); }, 1600);
//         }
//         if (live) live.textContent = 'Added to cart';
//       })
//       .catch(function(err){
//         if (error) {
//           error.textContent = err && err.message ? err.message : 'Could not add this item to cart.';
//           error.hidden = false;
//         }
//         if (live) live.textContent = 'Cart error';
//       })
//       .finally(function(){
//         updatePdp(root, product);
//         if (button) {
//           button.removeAttribute('aria-busy');
//           var latest = updatePdp(root, product);
//           button.disabled = !(latest && latest.available);
//         }
//       });
//   }

//   function initRoot(root){
//     if (!root || root.__petsoPdpReady) return;
//     root.__petsoPdpReady = true;
//     var product = parseProduct(root);
//     if (!product) return;

//     root.querySelectorAll('[data-petso-thumb]').forEach(function(button){
//       button.addEventListener('click', function(){
//         activateMedia(root, button.getAttribute('data-petso-media-id'), button.getAttribute('data-petso-fallback-media'));
//       });
//     });

//     root.querySelectorAll('[data-petso-option-index]').forEach(function(fieldset){
//       fieldset.querySelectorAll('[data-petso-option-value]').forEach(function(button){
//         button.addEventListener('click', function(){
//           fieldset.querySelectorAll('[data-petso-option-value]').forEach(function(btn){
//             btn.classList.remove('is-selected');
//             btn.setAttribute('aria-pressed', 'false');
//           });
//           button.classList.add('is-selected');
//           button.setAttribute('aria-pressed', 'true');
//           updatePdp(root, product);
//         });
//       });
//     });

//     var qtyInput = root.querySelector('[data-petso-qty]');
//     var minus = root.querySelector('[data-petso-qty-minus]');
//     var plus = root.querySelector('[data-petso-qty-plus]');
//     if (minus) minus.addEventListener('click', function(){ qtyInput.value = Math.max(1, intValue(qtyInput) - 1); updatePdp(root, product); });
//     if (plus) plus.addEventListener('click', function(){ qtyInput.value = Math.min(99, intValue(qtyInput) + 1); updatePdp(root, product); });
//     if (qtyInput) qtyInput.addEventListener('input', function(){ updatePdp(root, product); });

//     var form = root.querySelector('.petso-pdp-form');
//     if (form) form.addEventListener('submit', submitAddToCart.bind(null, root, product));

//     updatePdp(root, product);
//   }

//   function init(){
//     document.querySelectorAll('[data-petso-product-root]').forEach(initRoot);
//   }

//   document.addEventListener('DOMContentLoaded', init);
//   document.addEventListener('shopify:section:load', init);
// })();

// (function(){
//   if (window.__PetSoStaticPdpControlsLoaded) return;
//   window.__PetSoStaticPdpControlsLoaded = true;

//   function formatStaticTotal(price, qty){
//     price = Number(price || 549);
//     qty = Math.max(1, parseInt(qty, 10) || 1);
//     return 'RM ' + (price * qty).toLocaleString('en-MY');
//   }

//   function initStaticControls(){
//     document.querySelectorAll('[data-petso-static-controls]').forEach(function(root){
//       if (root.__petsoStaticControlsReady) return;
//       root.__petsoStaticControlsReady = true;
//       var price = Number(root.getAttribute('data-petso-static-price') || 549);
//       var qty = root.querySelector('[data-petso-static-qty]');
//       var total = root.querySelector('[data-petso-static-total]');
//       var label = root.querySelector('[data-petso-static-color-label]');

//       function updateTotal(){
//         if (!qty) return;
//         var value = Math.max(1, parseInt(qty.value, 10) || 1);
//         qty.value = value;
//         if (total) total.textContent = formatStaticTotal(price, value);
//       }

//       root.querySelectorAll('[data-petso-static-option]').forEach(function(button){
//         button.addEventListener('click', function(){
//           root.querySelectorAll('[data-petso-static-option]').forEach(function(btn){
//             btn.classList.remove('is-selected');
//             btn.setAttribute('aria-pressed', 'false');
//           });
//           button.classList.add('is-selected');
//           button.setAttribute('aria-pressed', 'true');
//           if (label) label.textContent = button.getAttribute('data-petso-static-option') || button.textContent.trim();
//         });
//       });

//       var minus = root.querySelector('[data-petso-static-minus]');
//       var plus = root.querySelector('[data-petso-static-plus]');
//       if (minus) minus.addEventListener('click', function(){ if (qty) qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); updateTotal(); });
//       if (plus) plus.addEventListener('click', function(){ if (qty) qty.value = Math.min(99, (parseInt(qty.value, 10) || 1) + 1); updateTotal(); });
//       if (qty) qty.addEventListener('input', updateTotal);
//       updateTotal();
//     });
//   }

//   document.addEventListener('DOMContentLoaded', initStaticControls);
//   document.addEventListener('shopify:section:load', initStaticControls);
// })();




(function(){
  if (window.__PetSoReferenceScriptLoaded) return;
  window.__PetSoReferenceScriptLoaded = true;

  var STORAGE_KEY = 'petso:dog-name';
  var DEFAULT_NAME = 'Bruno';
  var DEFAULT_ROTATING_NAMES = ['Luna','Max','Bella','Cooper','Daisy','Milo','Rosie','Finn','Nala','Charlie','Olive','Bruno'];
  var ROTATION_INTERVAL = 2400;
  var ROTATION_TRANSITION = 320;
  var NAME_TEXT_PATTERN = /(Bruno’s|Bruno's|Milo’s|Milo's|Biscuit’s|Biscuit's|your dog’s|your dog's|your pet’s|your pet's|Bruno|Milo|Biscuit|your dog|your pet)/gi;
  var autoPromptScheduled = false;
  var adaptiveHeaderController = null;
  var HEADER_HIDE_SCROLL_Y = 500;
  var HEADER_SHOW_UP_DISTANCE = 150;
  var HEADER_REHIDE_DOWN_DISTANCE = 40;
  var HEADER_TOP_REVEAL_Y = 24;

  function cleanName(value){
    value = (value || '').toString().trim();
    return value ? value.slice(0, 32) : DEFAULT_NAME;
  }

  function getStoredPetName(){
    try { return localStorage.getItem(STORAGE_KEY); }
    catch(e){ return null; }
  }

  function getPetName(){
    return cleanName(getStoredPetName());
  }

  function setPetName(value){
    var name = cleanName(value);
    try { localStorage.setItem(STORAGE_KEY, name); } catch(e){}
    try { sessionStorage.removeItem(STORAGE_KEY + ':dismissed'); } catch(e){}
    document.documentElement.style.setProperty('--petso-current-name-length', String(name.length));
    window.PetSoPetName = name;
    applyPetName(name);
    initRotatingNames();
    return name;
  }

  function possessive(name){
    return /s$/i.test(name) ? name + '’' : name + '’s';
  }

  function isPossessiveToken(token){
    return /(?:’s|'s)$/i.test(token || '');
  }

  function tokenMode(token){
    return isPossessiveToken(token) ? 'possessive' : 'name';
  }

  function replacementForToken(token, name){
    return tokenMode(token) === 'possessive' ? possessive(name) : name;
  }

  // function preparePetNameTrigger(el){
  //   if(!el) return;
  //   el.classList.add('petso-name-trigger');
  //   if(!el.hasAttribute('data-petso-name-trigger')) el.setAttribute('data-petso-name-trigger', '');
  //   if(!el.hasAttribute('role')) el.setAttribute('role', 'button');
  //   if(!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
  //   el.setAttribute('aria-label', "Change your dog's name");
  //   el.setAttribute('title', "Change your dog's name");
  // }


  function preparePetNameTrigger(el) {
    if (!el) return;

    var isRotatingName = el.hasAttribute('data-petso-rotating-name');

    /*
      Do not apply the generic animated name class to rotating names.
      It causes Chrome to repaint the name at the beginning of
      multi-line headings.
    */
    el.classList.toggle('petso-name-trigger', !isRotatingName);
    el.classList.toggle('petso-rotating-name-trigger', isRotatingName);

    if (isRotatingName) {
      var title = el.closest(
        '.petso-title, .petso-title-sm, .petso-page-hero-title'
      );

      if (title) {
        title.classList.add('petso-title--has-rotating-name');
      }
    }

    if (!el.hasAttribute('data-petso-name-trigger')) {
      el.setAttribute('data-petso-name-trigger', '');
    }

    if (!el.hasAttribute('role')) {
      el.setAttribute('role', 'button');
    }

    if (!el.hasAttribute('tabindex')) {
      el.setAttribute('tabindex', '0');
    }

    el.setAttribute('aria-label', "Change your dog's name");
    el.setAttribute('title', "Change your dog's name");
  }

  function preparePetNameTriggers(root){
    (root || document).querySelectorAll('[data-petso-name-trigger], [data-petso-pet-name], [data-petso-pet-possessive]').forEach(preparePetNameTrigger);
  }

  function createNameTrigger(text, mode){
    var span = document.createElement('span');
    span.className = 'petso-name-trigger petso-inline-name';
    span.setAttribute('data-petso-name-trigger', '');
    span.setAttribute('data-petso-generated-name', '');
    span.setAttribute('data-petso-name-mode', mode || 'name');
    span.setAttribute(mode === 'possessive' ? 'data-petso-pet-possessive' : 'data-petso-pet-name', '');
    span.textContent = text;
    preparePetNameTrigger(span);
    return span;
  }

  function updateGeneratedNameTriggers(root, name){
    (root || document).querySelectorAll('[data-petso-generated-name]').forEach(function(el){
      var mode = el.getAttribute('data-petso-name-mode') || 'name';
      el.textContent = mode === 'possessive' ? possessive(name) : name;
      preparePetNameTrigger(el);
    });
  }

  function replaceTextNodeWithNameTriggers(node, name){
    var original = node.nodeValue || '';
    NAME_TEXT_PATTERN.lastIndex = 0;
    if(!NAME_TEXT_PATTERN.test(original)) return;

    NAME_TEXT_PATTERN.lastIndex = 0;
    var fragment = document.createDocumentFragment();
    var cursor = 0;
    var match;

    while((match = NAME_TEXT_PATTERN.exec(original)) !== null){
      if(match.index > cursor){
        fragment.appendChild(document.createTextNode(original.slice(cursor, match.index)));
      }
      fragment.appendChild(createNameTrigger(replacementForToken(match[0], name), tokenMode(match[0])));
      cursor = match.index + match[0].length;
    }

    if(cursor < original.length){
      fragment.appendChild(document.createTextNode(original.slice(cursor)));
    }

    if(node.parentNode) node.parentNode.replaceChild(fragment, node);
  }

  function applyTextReplacement(root, name){
    if(!root) return;
    updateGeneratedNameTriggers(root, name);

    var skip = { SCRIPT:1, STYLE:1, NOSCRIPT:1, TEMPLATE:1, INPUT:1, TEXTAREA:1, SELECT:1, OPTION:1 };
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function(node){
        var p = node.parentElement;
        if(!p || skip[p.tagName] || p.closest('[data-petso-no-name-replace], [data-petso-name-trigger]')) return NodeFilter.FILTER_REJECT;
        var text = node.nodeValue || '';
        NAME_TEXT_PATTERN.lastIndex = 0;
        return NAME_TEXT_PATTERN.test(text) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
    var nodes = [];
    while(walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function(node){ replaceTextNodeWithNameTriggers(node, name); });
  }

  function applyPetName(name){
    document.querySelectorAll('[data-petso-pet-name]').forEach(function(el){ el.textContent = name; });
    document.querySelectorAll('[data-petso-pet-possessive]').forEach(function(el){ el.textContent = possessive(name); });
    document.querySelectorAll('[data-petso-pet-placeholder]').forEach(function(el){ el.setAttribute('placeholder', 'e.g. ' + name); });
    document.querySelectorAll('.petso-page, .petso-page-fragment, .petso-site-header, .petso-site-footer').forEach(function(el){ applyTextReplacement(el, name); });
    preparePetNameTriggers(document);
  }

  function reveal(){
    var els=document.querySelectorAll('.petso-reveal');
    if(!('IntersectionObserver' in window)){
      els.forEach(function(e){e.classList.add('is-visible')});
      return;
    }
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    },{threshold:.12,rootMargin:'0px 0px -60px 0px'});
    els.forEach(function(e){
      if(e.__petsoRevealReady || e.classList.contains('is-visible')) return;
      e.__petsoRevealReady = true;
      io.observe(e);
    });
  }

  function stopNameRotation(el){
    if(el.__petsoRotationTimer){
      window.clearInterval(el.__petsoRotationTimer);
      el.__petsoRotationTimer = null;
    }
    if(el.__petsoRotationSwapTimer){
      window.clearTimeout(el.__petsoRotationSwapTimer);
      el.__petsoRotationSwapTimer = null;
    }
  }

  function initRotatingNames(){
    var storedName = getStoredPetName();
    document.querySelectorAll('[data-petso-rotating-name]').forEach(function(el){
      stopNameRotation(el);
      preparePetNameTrigger(el);

      if(storedName){
        el.classList.remove('is-changing');
        el.textContent = cleanName(storedName);
        el.setAttribute('data-petso-pet-name','');
        return;
      }

      el.removeAttribute('data-petso-pet-name');
      var index = Number(el.getAttribute('data-petso-name-index') || 0) % DEFAULT_ROTATING_NAMES.length;
      el.textContent = DEFAULT_ROTATING_NAMES[index];

      el.__petsoRotationTimer = window.setInterval(function(){
        el.classList.add('is-changing');
        el.__petsoRotationSwapTimer = window.setTimeout(function(){
          index = (index + 1) % DEFAULT_ROTATING_NAMES.length;
          el.setAttribute('data-petso-name-index', String(index));
          el.textContent = DEFAULT_ROTATING_NAMES[index];
          el.classList.remove('is-changing');
        }, ROTATION_TRANSITION);
      }, ROTATION_INTERVAL);
    });
  }

  function getNameModals(){
    return Array.prototype.slice.call(document.querySelectorAll('[data-petso-name-modal]'));
  }

  function getPrimaryNameModal(){
    var modals = getNameModals();
    if(!modals.length) return null;
    var pageModal = modals.filter(function(modal){ return !!modal.closest('#MainContent'); })[0];
    return pageModal || modals[0];
  }

  function closeNameModal(modal){
    if(!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden','true');
    modal.removeAttribute('data-petso-manual-open');
    document.documentElement.classList.remove('petso-modal-open');
  }

  function updateNameSubmitState(modal){
    if(!modal) return;
    var input = modal.querySelector('[data-petso-name-input]');
    var start = modal.querySelector('[data-petso-name-submit]');
    if(start) start.disabled = !(input && input.value.trim());
  }

  function saveNameFromModal(modal){
    var input = modal && modal.querySelector('[data-petso-name-input]');
    if(!input || !input.value.trim()){
      updateNameSubmitState(modal);
      return;
    }
    setPetName(input.value);
    closeNameModal(modal);
  }

  function dismissNameModal(modal){
    try { sessionStorage.setItem(STORAGE_KEY + ':dismissed', '1'); } catch(e){}
    closeNameModal(modal);
  }

  function setupNameModal(modal){
    if(!modal || modal.__petsoModalReady) return;
    modal.__petsoModalReady = true;

    var input = modal.querySelector('[data-petso-name-input]');
    var start = modal.querySelector('[data-petso-name-submit]');
    var skip = modal.querySelector('[data-petso-name-skip]');

    if(start) start.addEventListener('click', function(){ saveNameFromModal(modal); });
    if(skip) skip.addEventListener('click', function(){ dismissNameModal(modal); });
    modal.addEventListener('click', function(event){ if(event.target === modal) dismissNameModal(modal); });

    if(input){
      input.addEventListener('keydown', function(e){
        if(e.key === 'Enter'){
          e.preventDefault();
          saveNameFromModal(modal);
        }
      });
      input.addEventListener('input', function(){ updateNameSubmitState(modal); });
    }

    updateNameSubmitState(modal);
  }

  function openPetNameModal(prefillCurrentName){
    var modal = getPrimaryNameModal();
    if(!modal) return;
    setupNameModal(modal);

    var input = modal.querySelector('[data-petso-name-input]');
    if(input){
      input.value = prefillCurrentName && getStoredPetName() ? cleanName(getStoredPetName()) : '';
      updateNameSubmitState(modal);
    }

    modal.setAttribute('data-petso-manual-open', prefillCurrentName ? 'true' : 'false');
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden','false');
    document.documentElement.classList.add('petso-modal-open');
    window.setTimeout(function(){ if(input) input.focus(); }, 160);
  }

  function petNameModal(){
    var modals = getNameModals();
    if(!modals.length) return;
    modals.forEach(setupNameModal);

    window.PetSoOpenNameModal = function(){ openPetNameModal(true); };

    var hasName = !!getStoredPetName();
    var dismissed = false;
    try { dismissed = sessionStorage.getItem(STORAGE_KEY + ':dismissed') === '1'; } catch(e){}

    if(!hasName && !dismissed && !autoPromptScheduled){
      autoPromptScheduled = true;
      window.setTimeout(function(){
        if(!getStoredPetName()) openPetNameModal(false);
      }, 1400);
    }
  }

  function setupPetNameTriggerEvents(){
    if(window.__PetSoNameTriggerEventsReady) return;
    window.__PetSoNameTriggerEventsReady = true;

    document.addEventListener('click', function(event){
      var trigger = event.target && event.target.closest && event.target.closest('[data-petso-name-trigger]');
      if(!trigger || trigger.closest('[data-petso-name-modal]')) return;
      event.preventDefault();
      event.stopPropagation();
      openPetNameModal(true);
    });

    document.addEventListener('keydown', function(event){
      var trigger = event.target && event.target.closest && event.target.closest('[data-petso-name-trigger]');
      if(!trigger || trigger.closest('[data-petso-name-modal]')) return;
      if(event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      openPetNameModal(true);
    });
  }

  function initAdaptiveHeader(){
    var header = document.querySelector('.petso-site-header');

    if(!header){
      if(adaptiveHeaderController) adaptiveHeaderController.destroy();
      adaptiveHeaderController = null;
      return;
    }

    if(adaptiveHeaderController && adaptiveHeaderController.header === header) return;
    if(adaptiveHeaderController) adaptiveHeaderController.destroy();

    var lastScrollY = Math.max(window.scrollY || document.documentElement.scrollTop || 0, 0);
    var upwardDistance = 0;
    var downwardDistance = 0;
    var frameId = null;
    var isHidden = false;
    var mobileMenu = header.querySelector('.petso-site-mobile-menu');

    function setHeaderHidden(hidden){
      if(isHidden === hidden) return;
      isHidden = hidden;
      header.classList.toggle('is-scroll-hidden', hidden);
      header.setAttribute('data-petso-header-state', hidden ? 'hidden' : 'visible');
    }

    function resetDirectionDistance(){
      upwardDistance = 0;
      downwardDistance = 0;
    }

    function hasActiveHeaderInteraction(){
      return !!(
        header.querySelector('details[open]') ||
        (document.activeElement && header.contains(document.activeElement))
      );
    }

    function updateHeaderOnScroll(){
      frameId = null;

      if(!header.isConnected){
        destroy();
        return;
      }

      var currentScrollY = Math.max(window.scrollY || document.documentElement.scrollTop || 0, 0);
      var delta = currentScrollY - lastScrollY;
      lastScrollY = currentScrollY;

      if(currentScrollY <= HEADER_TOP_REVEAL_Y || hasActiveHeaderInteraction()){
        setHeaderHidden(false);
        resetDirectionDistance();
        return;
      }

      if(Math.abs(delta) < 1) return;

      if(delta > 0){
        upwardDistance = 0;
        downwardDistance += delta;

        if(currentScrollY >= HEADER_HIDE_SCROLL_Y && downwardDistance >= HEADER_REHIDE_DOWN_DISTANCE){
          setHeaderHidden(true);
        }
        return;
      }

      downwardDistance = 0;
      upwardDistance += Math.abs(delta);

      if(isHidden && upwardDistance >= HEADER_SHOW_UP_DISTANCE){
        setHeaderHidden(false);
        upwardDistance = 0;
      }
    }

    function scheduleHeaderUpdate(){
      if(frameId !== null) return;
      frameId = window.requestAnimationFrame(updateHeaderOnScroll);
    }

    function revealForInteraction(){
      setHeaderHidden(false);
      resetDirectionDistance();
    }

    function handleMobileMenuToggle(){
      if(mobileMenu && mobileMenu.open) revealForInteraction();
    }

    function destroy(){
      window.removeEventListener('scroll', scheduleHeaderUpdate);
      window.removeEventListener('resize', scheduleHeaderUpdate);
      window.removeEventListener('pageshow', scheduleHeaderUpdate);
      header.removeEventListener('focusin', revealForInteraction);
      if(mobileMenu) mobileMenu.removeEventListener('toggle', handleMobileMenuToggle);
      if(frameId !== null) window.cancelAnimationFrame(frameId);
      frameId = null;
    }

    header.classList.remove('is-scroll-hidden');
    header.setAttribute('data-petso-header-state', 'visible');
    window.addEventListener('scroll', scheduleHeaderUpdate, { passive: true });
    window.addEventListener('resize', scheduleHeaderUpdate, { passive: true });
    window.addEventListener('pageshow', scheduleHeaderUpdate);
    header.addEventListener('focusin', revealForInteraction);
    if(mobileMenu) mobileMenu.addEventListener('toggle', handleMobileMenuToggle);

    adaptiveHeaderController = {
      header: header,
      destroy: destroy
    };
  }

  function normalizeCategory(value){
    return (value || '')
      .toString()
      .replace(/&amp;/g, '&')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function hubFilters(){
    document.querySelectorAll('[data-petso-hub]').forEach(function(wrap){
      if(wrap.__petsoHubFiltersReady) return;
      wrap.__petsoHubFiltersReady = true;

      var buttons = Array.prototype.slice.call(wrap.querySelectorAll('[data-petso-category-filter]'));
      var cards = Array.prototype.slice.call(wrap.querySelectorAll('[data-petso-article-category]'));
      var feature = wrap.querySelector('[data-petso-feature-category]');
      var empty = wrap.querySelector('[data-petso-filter-empty]');

      function itemMatches(item, selected){
        if(selected === 'all') return true;
        var raw = item.getAttribute('data-petso-article-category') || item.getAttribute('data-petso-feature-category') || '';
        return normalizeCategory(raw) === selected;
      }

      function applyFilter(selectedRaw){
        var selected = normalizeCategory(selectedRaw || 'all');
        var visibleCount = 0;

        buttons.forEach(function(button){
          var active = normalizeCategory(button.getAttribute('data-petso-category-filter')) === selected;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        if(feature){
          var showFeature = itemMatches(feature, selected);
          feature.hidden = !showFeature;
          feature.style.setProperty('display', showFeature ? '' : 'none', 'important');
        }

        cards.forEach(function(card){
          var show = itemMatches(card, selected);
          card.hidden = !show;
          card.style.setProperty('display', show ? '' : 'none', 'important');
          if(show){
            visibleCount += 1;
            card.classList.add('is-visible');
          }
        });

        if(empty){
          empty.hidden = visibleCount > 0;
          empty.style.setProperty('display', visibleCount > 0 ? 'none' : 'block', 'important');
        }
      }

      buttons.forEach(function(btn){
        btn.addEventListener('click', function(event){
          event.preventDefault();
          applyFilter(btn.getAttribute('data-petso-category-filter') || 'all');
        });
      });

      var activeButton = wrap.querySelector('[data-petso-category-filter].is-active') || buttons[0];
      if(activeButton) applyFilter(activeButton.getAttribute('data-petso-category-filter') || 'all');
    });
  }


  function waitlistSubmission(){
    document.querySelectorAll('[data-petso-waitlist-card]').forEach(function(card){
      if(card.__petsoWaitlistReady) return;
      card.__petsoWaitlistReady = true;
      var form = card.querySelector('form');
      if(!form) return;
      form.addEventListener('submit', function(){
        card.classList.add('is-submitted');
      });
    });
  }

  function bootPetSoPersonalization(){
    reveal();
    initAdaptiveHeader();
    initRotatingNames();
    applyPetName(getPetName());
    setupPetNameTriggerEvents();
    petNameModal();
    hubFilters();
    waitlistSubmission();
  }

  document.addEventListener('DOMContentLoaded', bootPetSoPersonalization);
  document.addEventListener('shopify:section:load', bootPetSoPersonalization);
})();
(function(){
  if (window.__PetSoPdpScriptLoaded) return;
  window.__PetSoPdpScriptLoaded = true;

  var CURRENCY_DECIMALS = {
    BIF: 0, CLP: 0, DJF: 0, GNF: 0, ISK: 0, JPY: 0, KMF: 0, KRW: 0, PYG: 0, RWF: 0, UGX: 0, VND: 0, VUV: 0, XAF: 0, XOF: 0, XPF: 0,
    BHD: 3, IQD: 3, JOD: 3, KWD: 3, LYD: 3, OMR: 3, TND: 3
  };

  function moneyPrecision(currency){
    currency = String(currency || '').toUpperCase();
    return Object.prototype.hasOwnProperty.call(CURRENCY_DECIMALS, currency) ? CURRENCY_DECIMALS[currency] : 2;
  }

  function formatCents(cents, thousands, decimal, precision, divisor){
    var n = (Number(cents || 0) / divisor).toFixed(precision);
    var parts = n.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return precision > 0 ? parts[0] + decimal + (parts[1] || '').padEnd(precision, '0') : parts[0];
  }

  function shopifyMoney(cents, format, currency){
    var precision = moneyPrecision(currency);
    var divisor = Math.pow(10, precision);
    return String(format || '').replace(/{{\s*(\w+)\s*}}/g, function(_, token){
      var thousands = ',';
      var decimal = '.';
      var displayPrecision = precision;
      if (token === 'currency') return currency || '';
      if (token === 'amount_no_decimals') displayPrecision = 0;
      if (token === 'amount_with_comma_separator') { thousands = '.'; decimal = ','; }
      if (token === 'amount_no_decimals_with_comma_separator') { thousands = '.'; decimal = ','; displayPrecision = 0; }
      if (token === 'amount_no_decimals_with_space_separator') { thousands = ' '; displayPrecision = 0; }
      if (token === 'amount_with_space_separator') { thousands = ' '; decimal = ','; }
      if (token === 'amount_with_period_and_space_separator') { thousands = ' '; decimal = '.'; }
      if (token === 'amount_with_apostrophe_separator') { thousands = "'"; decimal = '.'; }
      return formatCents(cents, thousands, decimal, displayPrecision, divisor);
    });
  }

  function money(cents, root){
    cents = Number(cents || 0);
    var currency = 'USD';
    var format = '';
    try {
      currency = (root && root.getAttribute('data-petso-currency')) || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || currency;
      format = (root && root.getAttribute('data-petso-money-format')) || '';
    } catch(e) {}
    if (format && /{{\s*\w+\s*}}/.test(format)) {
      return shopifyMoney(cents, format, currency);
    }
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(cents / Math.pow(10, moneyPrecision(currency)));
    } catch(e) {
      return (cents / 100).toFixed(2);
    }
  }

  function intValue(input){
    var n = parseInt(input && input.value, 10);
    if (!Number.isFinite(n) || n < 1) n = 1;
    return n;
  }

  function uniqueSectionIds(){
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function(el){
      var id = el.getAttribute('data-section-id');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function route(path){
    var root = '/';
    try { root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; } catch(e) {}
    return root.replace(/\/$/, '') + path;
  }

  function safeCartCount(cart){
    var count = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
    count = Number(count || 0);
    return Number.isFinite(count) && count > 0 ? count : 0;
  }

  function updateCartBubbleMarkup(cart){
    var count = safeCartCount(cart);

    document.querySelectorAll('cart-icon.header-actions__cart-icon, .header-actions__cart-icon').forEach(function(icon){
      icon.classList.toggle('header-actions__cart-icon--has-cart', count > 0);
    });

    document.querySelectorAll('.cart-bubble').forEach(function(bubble){
      bubble.classList.toggle('visually-hidden', count <= 0);
      bubble.setAttribute('aria-hidden', count > 0 ? 'false' : 'true');

      var countNode = bubble.querySelector('[ref="cartBubbleCount"], .cart-bubble__text-count');
      if (countNode) {
        countNode.textContent = count > 99 ? '' : String(count);
        countNode.classList.toggle('hidden', count <= 0);
      }
    });

    try {
      sessionStorage.setItem('cart-count', JSON.stringify({ value: String(count), timestamp: Date.now() }));
    } catch(e) {}
  }

  function announceCartUpdate(cart){
    var count = safeCartCount(cart);
    document.querySelectorAll('[data-testid="cart-count-live-region"], [data-petso-live-region]').forEach(function(region){
      region.textContent = count > 0 ? ('Cart updated. ' + count + ' item' + (count === 1 ? '' : 's') + ' in cart.') : 'Cart is empty.';
    });
  }

  function parseProduct(root){
    var script = root.querySelector('[data-petso-product-json]');
    if (!script) return null;
    try { return JSON.parse(script.textContent || '{}'); }
    catch(e) { return null; }
  }

  function getSelectedOptions(root){
    return Array.prototype.map.call(root.querySelectorAll('[data-petso-option-index]'), function(fieldset){
      var selected = fieldset.querySelector('[data-petso-option-value].is-selected') || fieldset.querySelector('[data-petso-option-value]');
      return selected ? selected.getAttribute('data-petso-option-value') : '';
    });
  }

  function findVariant(product, selectedOptions){
    if (!product || !Array.isArray(product.variants)) return null;
    if (!selectedOptions.length && product.variants.length) return product.variants[0];
    return product.variants.find(function(variant){
      return Array.isArray(variant.options) && variant.options.every(function(option, index){
        return String(option) === String(selectedOptions[index]);
      });
    }) || null;
  }

  function setSelectedOptionLabels(root, selectedOptions){
    selectedOptions.forEach(function(value, index){
      var label = root.querySelector('[data-petso-selected-option="' + index + '"]');
      if (label) label.textContent = value;
    });
  }

  function updateAvailability(root, product, selectedOptions){
    root.querySelectorAll('[data-petso-option-index]').forEach(function(fieldset){
      var index = Number(fieldset.getAttribute('data-petso-option-index'));
      fieldset.querySelectorAll('[data-petso-option-value]').forEach(function(button){
        var test = selectedOptions.slice();
        test[index] = button.getAttribute('data-petso-option-value') || '';
        var variant = findVariant(product, test);
        button.classList.toggle('is-unavailable', !!variant && variant.available === false);
      });
    });
  }

  function activateMedia(root, mediaId, fallbackIndex){
    var selector = null;
    if (mediaId) selector = '[data-petso-media-id="' + mediaId + '"]';
    if (!selector && fallbackIndex !== undefined && fallbackIndex !== null) selector = '[data-petso-fallback-media="' + fallbackIndex + '"]';
    if (!selector) return;

    var main = root.querySelector('[data-petso-main-media]' + selector);
    var thumb = root.querySelector('[data-petso-thumb]' + selector);
    if (!main) return;

    root.querySelectorAll('[data-petso-main-media]').forEach(function(el){ el.classList.remove('is-active'); });
    root.querySelectorAll('[data-petso-thumb]').forEach(function(el){ el.classList.remove('is-active'); });
    main.classList.add('is-active');
    if (thumb) thumb.classList.add('is-active');
  }

  function variantMediaId(variant){
    if (!variant) return null;
    if (variant.featured_media && variant.featured_media.id) return String(variant.featured_media.id);
    if (variant.featured_image && variant.featured_image.id) return String(variant.featured_image.id);
    return null;
  }

  function updatePdp(root, product){
    var selectedOptions = getSelectedOptions(root);
    var variant = findVariant(product, selectedOptions);
    var qtyInput = root.querySelector('[data-petso-qty]');
    var qty = intValue(qtyInput);
    if (qtyInput) qtyInput.value = qty;

    setSelectedOptionLabels(root, selectedOptions);
    updateAvailability(root, product, selectedOptions);

    var idInput = root.querySelector('[data-petso-variant-id]');
    var price = root.querySelector('[data-petso-price]');
    var compare = root.querySelector('[data-petso-compare-price]');
    var badge = root.querySelector('[data-petso-discount-badge]');
    var add = root.querySelector('[data-petso-add-to-cart]');
    var defaultLabel = root.querySelector('.petso-pdp-atc__default');
    var status = root.querySelector('[data-petso-status]');
    var availableText = status ? (status.getAttribute('data-available-text') || 'Checkout opens at launch. Shopify-powered, secure payments.') : '';
    var unavailableText = status ? (status.getAttribute('data-unavailable-text') || 'This variant is currently unavailable.') : '';

    if (!variant) {
      if (add) add.disabled = true;
      if (defaultLabel) defaultLabel.textContent = 'Unavailable';
      if (status) status.textContent = unavailableText;
      return null;
    }

    if (idInput) idInput.value = variant.id;
    if (price) price.textContent = money(variant.price, root);

    if (compare) {
      var defaultBadge = badge ? (badge.getAttribute('data-petso-badge-default') || '') : '';
      if (variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price)) {
        compare.textContent = money(variant.compare_at_price, root);
        compare.classList.remove('is-hidden');
        if (badge) {
          var discount = Math.round((Number(variant.compare_at_price) - Number(variant.price)) * 100 / Number(variant.compare_at_price));
          badge.textContent = defaultBadge || ('Save ' + discount + '%');
          badge.hidden = false;
        }
      } else {
        compare.textContent = '';
        compare.classList.add('is-hidden');
        if (badge) {
          badge.textContent = defaultBadge;
          badge.hidden = !defaultBadge;
        }
      }
    }

    if (defaultLabel) {
      defaultLabel.innerHTML = (variant.available ? 'Add to cart' : 'Sold out') + ' — <span data-petso-total-price>' + money(Number(variant.price) * qty, root) + '</span>';
    }
    if (add) add.disabled = !variant.available;
    if (status) {
      status.textContent = variant.available ? availableText : unavailableText;
    }

    var mediaId = variantMediaId(variant);
    if (mediaId) activateMedia(root, mediaId, null);

    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    } catch(e) {}

    return variant;
  }

  function dispatchCartUpdate(cart, addResponse, variantId){
    var sections = addResponse && addResponse.sections ? addResponse.sections : {};
    var itemCount = safeCartCount(cart);

    updateCartBubbleMarkup(cart);
    announceCartUpdate(cart);

    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart || {},
        sourceId: 'petso-product-form',
        data: {
          // Keep this different from product-form-component because the value below is the full cart count.
          source: 'petso-product-form',
          itemCount: itemCount,
          variantId: variantId ? String(variantId) : undefined,
          sections: sections
        }
      }
    }));
  }

  function openCartDrawer(){
    var drawer = document.querySelector('cart-drawer-component');
    var trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
    if (!drawer) {
      if (trigger) trigger.click();
      return;
    }
    var open = function(){
      if (typeof drawer.open === 'function') drawer.open();
      else if (typeof drawer.showDialog === 'function') drawer.showDialog();
      else if (trigger) trigger.click();
    };
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('cart-drawer-component').then(function(){ window.setTimeout(open, 40); }).catch(function(){ if (trigger) trigger.click(); });
    } else {
      window.setTimeout(open, 40);
    }
  }

  function submitAddToCart(root, product, event){
    event.preventDefault();
    var form = event.currentTarget;
    var variant = updatePdp(root, product);
    var button = root.querySelector('[data-petso-add-to-cart]');
    var error = root.querySelector('[data-petso-form-error]');
    var live = root.querySelector('[data-petso-live-region]');

    if (!variant || !variant.available) return;
    if (error) {
      error.hidden = true;
      error.textContent = '';
    }
    if (button) {
      button.disabled = true;
      button.classList.remove('is-added');
      button.setAttribute('aria-busy', 'true');
    }

    var formData = new FormData(form);
    formData.set('id', String(variant.id));
    var qtyInput = root.querySelector('[data-petso-qty]');
    formData.set('quantity', String(intValue(qtyInput)));

    var sections = uniqueSectionIds();
    if (sections.length) {
      formData.set('sections', sections.join(','));
      formData.set('sections_url', window.location.pathname);
    }

    fetch(route('/cart/add.js'), {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    })
      .then(function(response){ return response.json().then(function(json){ return { ok: response.ok, json: json }; }); })
      .then(function(result){
        if (!result.ok || result.json.status) {
          var message = result.json.description || result.json.message || 'Could not add this item to cart.';
          throw new Error(Array.isArray(message) ? message.join(', ') : message);
        }
        return fetch(route('/cart.js'), { credentials: 'same-origin' })
          .then(function(response){ return response.json(); })
          .then(function(cart){ return { cart: cart, addResponse: result.json }; });
      })
      .then(function(result){
        dispatchCartUpdate(result.cart, result.addResponse, variant.id);
        window.setTimeout(openCartDrawer, 90);
        if (button) {
          button.classList.add('is-added');
          window.setTimeout(function(){ button.classList.remove('is-added'); }, 1600);
        }
        if (live) live.textContent = 'Added to cart';
      })
      .catch(function(err){
        if (error) {
          error.textContent = err && err.message ? err.message : 'Could not add this item to cart.';
          error.hidden = false;
        }
        if (live) live.textContent = 'Cart error';
      })
      .finally(function(){
        updatePdp(root, product);
        if (button) {
          button.removeAttribute('aria-busy');
          var latest = updatePdp(root, product);
          button.disabled = !(latest && latest.available);
        }
      });
  }

  function initRoot(root){
    if (!root || root.__petsoPdpReady) return;
    root.__petsoPdpReady = true;
    var product = parseProduct(root);
    if (!product) return;

    root.querySelectorAll('[data-petso-thumb]').forEach(function(button){
      button.addEventListener('click', function(){
        activateMedia(root, button.getAttribute('data-petso-media-id'), button.getAttribute('data-petso-fallback-media'));
      });
    });

    root.querySelectorAll('[data-petso-option-index]').forEach(function(fieldset){
      fieldset.querySelectorAll('[data-petso-option-value]').forEach(function(button){
        button.addEventListener('click', function(){
          fieldset.querySelectorAll('[data-petso-option-value]').forEach(function(btn){
            btn.classList.remove('is-selected');
            btn.setAttribute('aria-pressed', 'false');
          });
          button.classList.add('is-selected');
          button.setAttribute('aria-pressed', 'true');
          updatePdp(root, product);
        });
      });
    });

    var qtyInput = root.querySelector('[data-petso-qty]');
    var minus = root.querySelector('[data-petso-qty-minus]');
    var plus = root.querySelector('[data-petso-qty-plus]');
    if (minus) minus.addEventListener('click', function(){ qtyInput.value = Math.max(1, intValue(qtyInput) - 1); updatePdp(root, product); });
    if (plus) plus.addEventListener('click', function(){ qtyInput.value = Math.min(99, intValue(qtyInput) + 1); updatePdp(root, product); });
    if (qtyInput) qtyInput.addEventListener('input', function(){ updatePdp(root, product); });

    var form = root.querySelector('.petso-pdp-form');
    if (form) form.addEventListener('submit', submitAddToCart.bind(null, root, product));

    updatePdp(root, product);
  }

  function init(){
    document.querySelectorAll('[data-petso-product-root]').forEach(initRoot);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();

(function(){
  if (window.__PetSoStaticPdpControlsLoaded) return;
  window.__PetSoStaticPdpControlsLoaded = true;

  function formatStaticTotal(price, qty){
    price = Number(price || 549);
    qty = Math.max(1, parseInt(qty, 10) || 1);
    return 'RM ' + (price * qty).toLocaleString('en-MY');
  }

  function initStaticControls(){
    document.querySelectorAll('[data-petso-static-controls]').forEach(function(root){
      if (root.__petsoStaticControlsReady) return;
      root.__petsoStaticControlsReady = true;
      var price = Number(root.getAttribute('data-petso-static-price') || 549);
      var qty = root.querySelector('[data-petso-static-qty]');
      var total = root.querySelector('[data-petso-static-total]');
      var label = root.querySelector('[data-petso-static-color-label]');

      function updateTotal(){
        if (!qty) return;
        var value = Math.max(1, parseInt(qty.value, 10) || 1);
        qty.value = value;
        if (total) total.textContent = formatStaticTotal(price, value);
      }

      root.querySelectorAll('[data-petso-static-option]').forEach(function(button){
        button.addEventListener('click', function(){
          root.querySelectorAll('[data-petso-static-option]').forEach(function(btn){
            btn.classList.remove('is-selected');
            btn.setAttribute('aria-pressed', 'false');
          });
          button.classList.add('is-selected');
          button.setAttribute('aria-pressed', 'true');
          if (label) label.textContent = button.getAttribute('data-petso-static-option') || button.textContent.trim();
        });
      });

      var minus = root.querySelector('[data-petso-static-minus]');
      var plus = root.querySelector('[data-petso-static-plus]');
      if (minus) minus.addEventListener('click', function(){ if (qty) qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); updateTotal(); });
      if (plus) plus.addEventListener('click', function(){ if (qty) qty.value = Math.min(99, (parseInt(qty.value, 10) || 1) + 1); updateTotal(); });
      if (qty) qty.addEventListener('input', updateTotal);
      updateTotal();
    });
  }

  document.addEventListener('DOMContentLoaded', initStaticControls);
  document.addEventListener('shopify:section:load', initStaticControls);
})();
